import React, { useState } from "react";
import { Col, Row, Card, CardBody, Modal, ModalBody } from "reactstrap";
import "./styles.scss";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ResaleService from "services/Website/ResaleService";
import PropertyService from "services/Website/PropertyService";
import { SuccessOk } from "configs/statusCode";
import { toast } from "react-toastify";

const MessageModal = ({ modal, setModal, item, type }) => {
	const { t } = useTranslation();
	const AuthData = useSelector((state) => state.Auth);
	const currency = useSelector((state) => state.Auth?.currency);
	const [loading, setLoading] = useState(false);
	const [message, setMessage] = useState("");
	const propertyService = new PropertyService();
	const resaleService = new ResaleService();

	const handleValidSubmit = (e, v) => {
		setLoading(true);
		if (type === "resale") {
			const data = {
				comment: v.message,
				resale_id: item.id,
				attattachment:
					item?.images?.length > 0 ? item.images.map((img) => img.path) : [],
			};
			resaleService.sendCil(data).then((res) => {
				if (res && res.status === SuccessOk) {
					toast.success("Message Sent successfully");
					setModal(false);
				}
				setLoading(false);
			});
		} else {
			const data = {
				comment: v.message,
				unit_id: item.id,
				attattachment:
					item?.images?.length > 0 ? item.images.map((img) => img.path) : [],
			};
			propertyService.sendCil(data).then((res) => {
				if (res && res.status === SuccessOk) {
					toast.success("Message Sent successfully");
					setModal(false);
				}
				setLoading(false);
			});
		}
	};

	return (
		<Modal
			isOpen={modal}
			toggle={() => setModal(false)}
			style={{ maxWidth: "600px", marginTop: "10%", width: "100%" }}
			className={`${
				AuthData.lang !== "ar" ? "websitPages" : "ar-wrapper websitPages"
			}`}>
			<ModalBody className="m-0 p-0 fw-bold">
				<div
					className="overflow-hidden m-0 p-0"
					style={{ direction: "inherit" }}>
					<div className=" p-0 m-0">
						<p className="bask-font fw-bold text-center fs-1 text-primary">
							{t("Message Sales Rep")}
						</p>
						<Row className="mx-4">
							<Col md={3} className="my-2 ">
								<Row className="font-size-14 text-color">{t("Unit Code")}</Row>
								<Row className="fw-bold text-primary">
									{item?.unit_type?.name[`${AuthData.lang}`]
										? item?.unit_type?.name[`${AuthData.lang}`]
										: item?.unit_type?.name.en}
								</Row>
							</Col>
							<Col md={3} className="my-2 ">
								<Row className="font-size-14 text-color">{t("location")}</Row>
								{type === "unit" && (
									<Row className="fw-bold text-primary">
										{item?.location?.area[`${AuthData.lang}`]
											? item?.location?.area[`${AuthData.lang}`]
											: item?.area?.name?.en}
									</Row>
								)}
								{type === "resale" && (
									<Row className="fw-bold text-primary">{item?.area?.name}</Row>
								)}
							</Col>
							<Col md={3} className="my-2 ">
								<Row className="font-size-14 text-color">{t("beds")}</Row>
								<Row className="fw-bold text-primary">{item?.bedrooms}</Row>
							</Col>
							<Col md={3} className="my-2 ">
								<Row className="font-size-14 text-color">{t("Size")}</Row>
								{type === "resale" ? (
									<Row className="fw-bold text-primary">
										{parseInt(item?.total_built_up_area).toFixed(0)} {t("sqm")}
									</Row>
								) : (
									<Row className="fw-bold text-primary">
										{parseInt(item?.size).toFixed(0)} {t("sqm")}
									</Row>
								)}
							</Col>
							<Col md={3} className="my-2 ">
								<Row className="font-size-14 text-color">{t("price")}</Row>
								{type === "unit" && (
									<Row className="fw-bold text-primary">
										{toCurrency(item?.price)} {currency?.currency_code}
									</Row>
								)}
								{type == "resale" && (
									<Row className="fw-bold text-primary">
										{toCurrency(item?.payment_plan?.total_price)}{" "}
										{currency?.currency_code}
									</Row>
								)}
							</Col>
							<Col md={3} className="my-2 ">
								<Row className="font-size-14 text-color">{t("Unit Type")}</Row>
								<Row className="fw-bold text-primary">
									{" "}
									{item?.unit_type?.name[`${AuthData.lang}`]
										? item?.unit_type?.name[`${AuthData.lang}`]
										: item?.unit_type?.name.en}
								</Row>
							</Col>
						</Row>
						<Row className="my-4 mx-2 fw-bold font-size-16">
							<AvForm
								className="form-horizontal"
								onValidSubmit={(e, v) => {
									handleValidSubmit(e, v);
								}}>
								<label className="text-primary">Message</label>
								<AvField
									name="message"
									placeholder="Type Message"
									className="form-control"
									type="textarea"
									bsSize="lg"
									style={{
										background: "none",
										borderColor: "var(--primary-color)",
									}}
								/>
								<div className="mt-4">
									<button
										className="btn btn-primary br-25 w-100 btnHeight"
										disabled={loading}>
										{t("Submit")}
									</button>
								</div>
							</AvForm>
						</Row>
					</div>
				</div>
			</ModalBody>
		</Modal>
	);
};
const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};
export default MessageModal;
